const ORDER_TOASTS = {
    ORDER_ADDED: "Order added successfully!",
    ORDER_NOT_ADDED: "Failed to add order",
    
}
export default ORDER_TOASTS